import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=dc6d9f3e&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=ts"
export * from "./EventDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6d9f3e",
  null
  
)

export default component.exports